export default __webpack_public_path__ + "static/media/4.b9f0664b.png";